<template>
	<div class="usercp-primary">
		<div class="header">
			<h3>我的赞过的文章</h3>
		</div>
		<div class="datalist" v-for="item in list" style="margin-top: 30px">
			<div
				class="card card-flex"
				style="border-bottom: solid 1px #ddd; padding-bottom: 15px; margin-bottom: 20px"
			>
				<div class="card-img" style="min-width: 180px; margin-right: 15px">
					<a
						:href="item.url"
						class="thumb cover p16x9"
						style="display:block"
						target="_blank"
					>
						<img :src="item.thumb" />
					</a>
				</div>
				<div class="card-body">
					<a
						@click="cancle(item.id)"
						href="javascript:void(0)"
						style="float: right"
						><i class="fa fa-trash"></i> 删除</a
					>
					<a :href="item.url" class="title">{{ item.title }}</a>
					<div class="summary">{{ item.summary }}</div>
				</div>
			</div>
		</div>

		<div v-if="!list.length" class="notfound text-center">暂无信息</div>
		<div v-if="total > 0" class="text-center">
			<el-pagination
				background
				layout="prev, pager, next"
				@current-change="getList"
				:current-page.sync="curPage"
				:page-size="parseInt(pageSize)"
				:total="total"
			/>
		</div>
	</div>
</template>
<script>
export default {
	name: "collect",
	data() {
		return {
			user: undefined,
			total: 0,
			curPage: 1,
			pageSize: 20,
			list: [],
			loading: true
		};
	},
	methods: {
		getList(page, callback) {
			this.curPage = page;
			this.loading = true;
			this.axios
				.get(this.axios.apiGateway + "like/article", {
					params: {
						refType: this.refType,
						pagesize: this.pageSize,
						uid: this.user ? this.user.id : 0,
						page: page
					}
				})
				.then(res => {
					this.total = parseInt(res.data.total);
					this.list = res.data.list;
					this.loading = false;
					if (callback) {
						callback(res);
					}
				});
		},
		cancle(id) {
			this.$confirm("确定要取消收藏吗", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				this.axios
					.get(this.axios.apiGateway + "follow/like", {
						params: {
							token: this.user.token,
							refType: "Page",
							refId: id
						}
					})
					.then(res => {
						if (res.data.errcode) {
							this.$message.error(res.data.errmsg);
						} else {
							this.count = res.data.num;
							if (res.data.status) {
								this.$message.success("点赞成功！");
							} else {
								this.$message.info("取消点赞！");
							}
							this.getList(1);
						}
					});
			});
		}
	},
	created() {
		this.$store.dispatch("notify", user => {
			this.user = user;
		});

		this.user = this.$store.getters.user;
		this.getList();
	}
};
</script>



// WEBPACK FOOTER //
// src/components/Usercp/Like.vue